import { Action } from '../../common/actions/core/action';
import { PackageThumbnail } from '../../common/services/package/package.model';

export class OpenPacketDeleteAction implements Action {
  constructor(
    public onDeleteSuccess: (packet: PackageThumbnail) => any,
    public packet: PackageThumbnail
  ) {}
}



// WEBPACK FOOTER //
// src/app/packet/packet-delete-dialog/packet-delete-dialog.action.ts